import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HeaderLanding = () => {
    const [isMobile, setIsMobile] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 998);
        };
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isLanding = location.pathname.includes('/landing');
    const isOnboarding = location.pathname.includes('/onboarding');

    const handleLogout = () => {
        localStorage.removeItem('storage'); 
        window.location.href = '/'
    }

    return (
        <>
            {isMobile ? (
                <div
                    className='mc_container_header_landing'
                >
                    <div className='__main' style={!isLanding ? { backgroundColor: 'rgba(12, 35, 134, 1)' } : {}}>
                        <div className='__logo'>
                            <figure>
                                <a href="#">
                                    {isLanding
                                        ? <img className='img-mobile-1' src='/assets/images/guayaquil.png' alt="" />
                                        : <img className='header-mobile-logos' src='/assets/images/header-mobile-logos.png' alt='Banco Guayaquil, peiGo y Mastercard' />
                                    }
                                </a>
                            </figure>
                        </div>

                        {isOnboarding ? (
                            <div className="close-btn" onClick={handleLogout}>
                                <img src="/assets/images/close-desktop.png" alt="Close" />
                            </div>
                        ) : (
                            <div className="close-btn" style={{ display: 'none' }}>
                                <img src="/assets/images/close-desktop.png" alt="Close" />
                            </div>
                        )}

                    </div>

                </div>
            ) : (
                <div
                    className='mc_container_header_landing'

                >
                    <div className='__main' style={!isLanding ? { backgroundColor: '#0C2386' } : {}}>
                        {isLanding ? (<div className='__logo'>
                            <figure>
                                <a href="#">
                                    <img src={isLanding ? '/assets/images/logos2.png' : '/assets/images/guayaquil_logo.png'} alt="" />
                                </a>
                            </figure>
                        </div>) : (
                            <div className='__logo'>
                                <div className='container-logo-mc'>
                                    <figure className='container-img-1'>
                                        <a href="#">
                                            <img className='img-1' src={isLanding ? '/assets/images/logos2.png' : '/assets/images/guayaquil.svg'} alt="" />
                                        </a>
                                    </figure>
                                    <div className='line_logo'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="33" viewBox="0 0 2 33" fill="none">
                                            <path d="M0.625 0V32.2235" stroke="white" strokeWidth="1.25" strokeMiterlimit="10"/>
                                        </svg>
                                    </div>
                                    <figure className='container-img-1_2'>
                                        <a href="#">
                                            <img className='img-1' src={isLanding ? '/assets/images/logos2.png' : '/assets/images/peigo.svg'} alt="" />
                                        </a>
                                    </figure>
                                </div>
                                <div className='container-logo-mc'>
                                    <figure  className='container-img-2'>
                                        <a href="#">
                                            <img className='img-2' src={isLanding ? '/assets/images/logos2.png' : '/assets/images/mc_color.png'} alt="" />
                                        </a>
                                    </figure>
                                </div>
                                {isOnboarding ? (
                                    <div className="close-btn" onClick={handleLogout}>
                                        <img src="/assets/images/close-desktop.png" alt="Close" />
                                    </div>
                                ) : (
                                    <div className="close-btn" style={{ display: 'none' }}>
                                        <img src="/assets/images/close-desktop.png" alt="Close" />
                                    </div>
                                )}
                            </div>)}
                        <div className='__text'></div>
                    </div>
                </div>
            )}
        </>
    );
}

export default HeaderLanding;
